// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2cc4a6f","667":"455c901e","726":"2efc1f8a"}[chunkId] + ".chunk.js";
};